var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.83 98.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.69,20.32l9.59-9.54v51.02c0,2.01,1.63,3.63,3.63,3.63s3.63-1.63,3.63-3.63V11.07l9.73,9.52c.61.59,1.39.89,2.18.89s1.62-.31,2.23-.94c1.2-1.23,1.18-3.2-.05-4.41L42.09,1.9c-.62-1.13-1.8-1.9-3.18-1.9-.87,0-1.66.32-2.29.83-.27.17-.54.35-.77.59l-14.55,14.48c-1.22,1.21-1.22,3.19-.01,4.41s3.19,1.22,4.41.01Z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.23,27.21h-14.52v7.27h14.52c2.39,0,4.34,1.96,4.34,4.37v48.36c0,2.41-1.95,4.37-4.34,4.37H11.61c-2.39,0-4.34-1.96-4.34-4.37v-48.36c0-2.41,1.95-4.37,4.34-4.37h14.31v-7.27h-14.31c-6.4,0-11.61,5.22-11.61,11.64v48.36c0,6.42,5.21,11.64,11.61,11.64h54.62c6.4,0,11.61-5.22,11.61-11.64v-48.36c0-6.42-5.21-11.64-11.61-11.64Z",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.3d28bea9a8046dfcc322eebc2dbf428e.svg";
export { ForwardRef as ReactComponent };